import { render, staticRenderFns } from "./simpleSizing.vue?vue&type=template&id=7f78ee28&"
import script from "./simpleSizing.vue?vue&type=script&lang=js&"
export * from "./simpleSizing.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./simpleSizing.vue?vue&type=style&index=0&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports